export default __webpack_public_path__ + "static/media/information--end-of-living-street--g1.b9ad088e.png";